export default __webpack_public_path__ + "static/media/bella-ramsey_4.ad3ff615.jpg";